import React from 'react';

const Story = (props) => {
    return (
        <section className="timeline-1">
            <div className="container">
                <div className="row">
                    <div className="col-md-8 col-md-offset-2 col-sm-10 col-sm-offset-1 text-center">
                        <h1>{props.data.title}</h1>
                        <p className="lead">{props.data.description}</p>    
                    </div>
                </div>
                
                <div className="row">
                    <div className="col-sm-12">
                        {props.data.list ? 
                            (
                                props.data.list.map((item, itemIndex) => {
                                    return (
                                        <div key={itemIndex} className="timeline-event">
                                            <div className={`col-sm-6 ${itemIndex % 2 === 0 ? 'col-md-push-6' : ''}`}>
                                                <h2>{item.duration}</h2>
                                                <h5>{item.title}</h5>
                                            </div>                              
                                            <div className="middle">
                                                <i className={`icon ${item.icon}`}></i>
                                                <div className="vertical-line"></div>
                                            </div>                              
                                            <div className={`col-sm-6 ${itemIndex % 2 === 0 ? 'col-md-pull-6' : ''}`}>
                                                <p>{item.description}</p>
                                            </div>
                                        </div>
                                    );
                                })
                            )
                        : null
                        }
                        
                    </div>
                </div>        
            </div>
        </section>
    )
}

export default Story;